import { render, staticRenderFns } from "./tagPicker.vue?vue&type=template&id=745b75d2&scoped=true&"
import script from "./tagPicker.vue?vue&type=script&lang=js&"
export * from "./tagPicker.vue?vue&type=script&lang=js&"
import style0 from "./tagPicker.vue?vue&type=style&index=0&id=745b75d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745b75d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('745b75d2')) {
      api.createRecord('745b75d2', component.options)
    } else {
      api.reload('745b75d2', component.options)
    }
    module.hot.accept("./tagPicker.vue?vue&type=template&id=745b75d2&scoped=true&", function () {
      api.rerender('745b75d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/picker/tagPicker.vue"
export default component.exports